import { render } from "./filePreviewDialog.vue?vue&type=template&id=3f9aa617&scoped=true"
import script from "./filePreviewDialog.vue?vue&type=script&lang=js"
export * from "./filePreviewDialog.vue?vue&type=script&lang=js"

import "./filePreviewDialog.vue?vue&type=style&index=0&id=3f9aa617&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9aa617"]])

export default __exports__